import { getValidationSchema } from '../../../common.validators';
import { FORM_FIELDS } from '../../../../../constants';

export const schema = () =>
    getValidationSchema([
        FORM_FIELDS.REGISTRATION_STREET,
        FORM_FIELDS.REGISTRATION_APARTMENT,
        FORM_FIELDS.REGISTRATION_DATE,

        FORM_FIELDS.RESIDENCE_STREET,
        FORM_FIELDS.RESIDENCE_APARTMENT,

        FORM_FIELDS.EDUCATION,
        FORM_FIELDS.FAMILY_STATUS,
        FORM_FIELDS.NUMBER_OF_DEPENDENTS,
        FORM_FIELDS.EMAIL,
        FORM_FIELDS.ADDITIONAL_PHONE,
        FORM_FIELDS.ADDITIONAL_PHONE_OWNER,
        FORM_FIELDS.ADDITIONAL_PHONE_OWNER_FIO,
    ]);
